<div class="cockpit-content">
  <h1>{{ 'm2.sprint9.cockpit.card.weitereFunktionenstatistiken.title' | translate }}</h1>
  <app-chart-download-button (buttonClick)="exportTable1()">
    @if (isForM2) {
      <h2 class="title" translate>sprint9.cockpit.card.all.tabelle</h2>
    }
    @if (!isForM2) {
      <h2 class="title" translate>m1.sprint9.cockpit.card.funktionenstatistiken.fn.subtitle</h2>
    }
  </app-chart-download-button>

  <div  class="table-wrapper pdb-30">
    <table id="wfunkstat.fn" class="striped">
      <thead>
        <tr>
          <td rowspan="2" class="no-border"><br><br></td>
          @if (!isForM2) {
            <th rowspan="2" scope="col" class="header bold centered border-bold-left border-bold-right" translate>
            m1.sprint10.cockpit.card.weitereFunktionenstatistiken.bst</th>
            <th rowspan="2" scope="col" class="header bold centered border-bold-right" translate>
            m1.sprint10.cockpit.card.weitereFunktionenstatistiken.bkn</th>
          }
          @if (isForM2) {
            <th rowspan="2" scope="col" class="header bold centered border-bold-left border-bold-right pt-md-2"
              [innerHTML]="'m2.sprint9.cockpit.card.weitereFunktionenstatistiken.funktionswert.umbruch' |translate">
            </th>
            <th rowspan="2" scope="col" class="header bold centered border-bold-right" translate>
            m2.sprint9.cockpit.card.weitereFunktionenstatistiken.anforderungAusbildung</th>
            <th rowspan="2" scope="col" class="header bold centered border-bold-right" translate>
            m2.sprint9.cockpit.card.weitereFunktionenstatistiken.effektiveAusbildungSkala1-5</th>
          }
          <th rowspan="2" colspan="8" scope="colgroup" class="header bold centered border-bold-right" translate>
          m2.sprint9.cockpit.card.weitereFunktionenstatistiken.ausbildung</th>
          <th rowspan="1" colspan="9" scope="colgroup" class="header bold centered border-bold-right" translate>
          m2.sprint9.cockpit.card.weitereFunktionenstatistiken.imMonatslohnArbeitspensumLohn</th>
          <th rowspan="1" colspan="9" scope="colgroup" class="header bold centered border-bold-right" translate>
          m2.sprint9.cockpit.card.weitereFunktionenstatistiken.imStundenlohnArbeitspensumLohn</th>
          @if (!isForM2) {
            <th rowspan="1" colspan="3" scope="colgroup" class="header bold centered border-bold-right"
            translate>m1.sprint10.cockpit.card.weitere-funktionenstatistiken.abweichung-gesamtverdienst</th>
          }
        </tr>
        <tr>
          <th scope="colgroup" colspan="3" class="header centered border-bold-right" translate>
          m2.sprint9.cockpit.card.weitereFunktionenstatistiken.beschäftigungsgrad</th>
          <th scope="colgroup" colspan="3" class="header centered border-bold-right" translate>
          m2.sprint9.cockpit.card.weitereFunktionenstatistiken.grundlohnUnstandardisiert13</th>
          <th scope="colgroup" colspan="3" class="header centered border-bold-right" translate>
          m2.sprint9.cockpit.card.weitereFunktionenstatistiken.gesamtverdienstStandardisiert</th>
          <th scope="colgroup" colspan="3" class="header centered border-bold-right" translate>
          m2.sprint9.cockpit.card.weitereFunktionenstatistiken.bezahlteStunden</th>
          <th scope="colgroup" colspan="3" class="header centered border-bold-right" translate>
          m2.sprint9.cockpit.card.weitereFunktionenstatistiken.grundlohnUnstandardisiert13</th>
          <th scope="colgroup" colspan="3" class="header centered border-bold-right" translate>
          m2.sprint9.cockpit.card.weitereFunktionenstatistiken.gesamtverdienstStandardisiert</th>
          @if (!isForM2) {
            <th scope="colgroup" colspan="3" class="header centered border-bold-right" translate>
            m1.sprint10.cockpit.card.weitere-funktionenstatistiken.diff-mittelwert</th>
          }
        </tr>
        <tr>
          <th scope="col" colspan="1" class="header bold centered border-bold-left border-bold-right" translate>
          m2.sprint9.cockpit.card.weitereFunktionenstatistiken.funktion</th>
          <td class="centered border-bold-right"></td>
          @if (!isForM2) {
            <td class="centered border-bold-right"></td>
          }
          @if (isForM2) {
            <td class="centered border-bold-right" translate>
            m2.sprint9.cockpit.card.weitereFunktionenstatistiken.mittelwert</td>
            <td class="centered border-bold-right" translate>
            m2.sprint9.cockpit.card.weitereFunktionenstatistiken.mittelwert</td>
          }

          @for (i of [].constructor(8); track i; let idx = $index; let isLast = $last) {
            <td class="centered" [ngClass]="{'border-bold-right': isLast}">{{idx+1}}</td>
          }

          @for (i of [].constructor(6); track i; let idx = $index; let isLast = $last) {
            <td class="centered" translate>i18n.common.min</td>
            <td class="centered" translate>i18n.common.max</td>
            <td class="centered border-bold-right" translate>
            m2.sprint9.cockpit.card.weitereFunktionenstatistiken.mittelwert</td>
          }
          @if (!isForM2) {
            <td class="centered" translate>i18n.common.maenner</td>
            <td class="centered" translate>i18n.common.frauen</td>
            <td class="centered border-bold-right" translate>i18n.common.gesamt</td>
          }
        </tr>
      </thead>
      <tbody>
        @for (item of nachFunktion; track item) {
          <tr class="content">
            <th scope="row" class="border-bold-left border-bold-right">{{item?.funktionId | retrieveCaption: funktionen}}
            </th>
            @if (!isForM2) {
              <td class="text-align-right border-bold-right">{{item.BST}}</td>
              <td class="text-align-right border-bold-right">{{item.BKN}}</td>
            }
            @if (isForM2) {
              <td class="text-align-right border-bold-right">{{item.funktionswert}}</td>
              <td class="text-align-right border-bold-right">{{item?.anforderungAnDieAusbildung | numberFormat: crtLocale
                }}
              </td>
              <td class="text-align-right border-bold-right">{{item?.effektiveAusbildung | numberFormat: crtLocale }}</td>
            }
            @for (i of [].constructor(8); track i; let isLast = $last; let idx = $index) {
              <td class="text-align-right" [ngClass]="{'border-bold-right': isLast}">{{item?.ausbildung[idx+1] |
              numberFormat: crtLocale }}</td>
            }
            <td class="text-align-right">{{item?.mitarbeitendeImMonatslohn?.beschaeftigungsgrad?.min | numberFormat:
            crtLocale }}</td>
            <td class="text-align-right">{{item?.mitarbeitendeImMonatslohn?.beschaeftigungsgrad?.max | numberFormat:
            crtLocale }}</td>
            <td class="text-align-right border-bold-right">
            {{item?.mitarbeitendeImMonatslohn?.beschaeftigungsgrad?.mittelwert | numberFormat: crtLocale }}</td>
            <td class="text-align-right">{{item?.mitarbeitendeImMonatslohn?.grundlohn?.min | numberFormat: crtLocale }}
            </td>
            <td class="text-align-right">{{item?.mitarbeitendeImMonatslohn?.grundlohn?.max | numberFormat: crtLocale }}
            </td>
            <td class="text-align-right border-bold-right">{{item?.mitarbeitendeImMonatslohn?.grundlohn?.mittelwert |
            numberFormat: crtLocale }}</td>
            <td class="text-align-right">{{item?.mitarbeitendeImMonatslohn?.gesamtverdienst?.min | numberFormat: crtLocale
            }}</td>
            <td class="text-align-right">{{item?.mitarbeitendeImMonatslohn?.gesamtverdienst?.max | numberFormat: crtLocale
            }}</td>
            <td class="text-align-right border-bold-right">{{item?.mitarbeitendeImMonatslohn?.gesamtverdienst?.mittelwert
              |
            numberFormat: crtLocale }}</td>
            <td class="text-align-right">{{item?.mitarbeitendeImStundenlohn?.bezahlteStunden?.min | numberFormat:
              crtLocale
            }}</td>
            <td class="text-align-right">{{item?.mitarbeitendeImStundenlohn?.bezahlteStunden?.max | numberFormat:
              crtLocale
            }}</td>
            <td class="text-align-right border-bold-right">
              {{item?.mitarbeitendeImStundenlohn?.bezahlteStunden?.mittelwert|
            numberFormat: crtLocale }}</td>
            <td class="text-align-right">{{item?.mitarbeitendeImStundenlohn?.grundlohn?.min | numberFormat: crtLocale }}
            </td>
            <td class="text-align-right">{{item?.mitarbeitendeImStundenlohn?.grundlohn?.max | numberFormat: crtLocale }}
            </td>
            <td class="text-align-right border-bold-right">{{item?.mitarbeitendeImStundenlohn?.grundlohn?.mittelwert |
            numberFormat: crtLocale }}</td>
            <td class="text-align-right">{{item?.mitarbeitendeImStundenlohn?.gesamtverdienst?.min | numberFormat:
              crtLocale
            }}</td>
            <td class="text-align-right">{{item?.mitarbeitendeImStundenlohn?.gesamtverdienst?.max | numberFormat:
              crtLocale
            }}</td>
            <td class="text-align-right border-bold-right">{{item?.mitarbeitendeImStundenlohn?.gesamtverdienst?.mittelwert
              |
            numberFormat: crtLocale }}</td>
            @if (!isForM2) {
              <td class="text-align-right">
                {{item.abweichungGeschlechtsneutralenGesamtverdienst?.maenner}}
              </td>
              <td class="text-align-right">
                {{item.abweichungGeschlechtsneutralenGesamtverdienst?.frauen}}
              </td>
              <td class="text-align-right border-bold-right">
                {{item.abweichungGeschlechtsneutralenGesamtverdienst?.gesamt}}
              </td>
            }
          </tr>
        }
      </tbody>
      <tfoot>
        <!-- total row -->
        <tr class="content">
          <th scope="col" colspan="1" class="border-bold-left border-bold-right border-bold-top" translate>
          i18n.common.total</th>
          @if (!isForM2) {
            <td class="text-align-right border-bold-right border-bold-top"></td>
          }
          <td class="text-align-right border-bold-right border-bold-top"></td>
          @if (isForM2) {
            <td class="text-align-right border-bold-right border-bold-top">
            {{gesamtesUnternehmen?.anforderungAnDieAusbildung | numberFormat: crtLocale }}</td>
            <td class="text-align-right border-bold-right border-bold-top">{{gesamtesUnternehmen?.effektiveAusbildung |
            numberFormat: crtLocale }}</td>
          }

          @for (i of [].constructor(8); track i; let isLast = $last; let idx = $index) {
            <td class="text-align-right border-bold-top" [ngClass]="{'border-bold-right': isLast}">
            {{gesamtesUnternehmen?.ausbildung[idx+1] | numberFormat: crtLocale }}</td>
          }

          <td class="text-align-right border-bold-top">
          {{gesamtesUnternehmen?.mitarbeitendeImMonatslohn?.beschaeftigungsgrad?.min | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top">
          {{gesamtesUnternehmen?.mitarbeitendeImMonatslohn?.beschaeftigungsgrad.max | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top border-bold-right">
            {{gesamtesUnternehmen?.mitarbeitendeImMonatslohn?.beschaeftigungsgrad?.mittelwert | numberFormat: crtLocale
            }}
          </td>

          <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.mitarbeitendeImMonatslohn?.grundlohn?.min
            |
          numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.mitarbeitendeImMonatslohn?.grundlohn?.max
            |
          numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top border-bold-right">
          {{gesamtesUnternehmen?.mitarbeitendeImMonatslohn?.grundlohn?.mittelwert | numberFormat: crtLocale }}</td>

          <td class="text-align-right border-bold-top">
          {{gesamtesUnternehmen?.mitarbeitendeImMonatslohn?.gesamtverdienst?.min | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top">
          {{gesamtesUnternehmen?.mitarbeitendeImMonatslohn?.gesamtverdienst?.max | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top border-bold-right">
            {{gesamtesUnternehmen?.mitarbeitendeImMonatslohn?.gesamtverdienst?.mittelwert | numberFormat: crtLocale }}
          </td>

          <td class="text-align-right border-bold-top">
          {{gesamtesUnternehmen?.mitarbeitendeImStundenlohn?.bezahlteStunden?.min | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top">
          {{gesamtesUnternehmen?.mitarbeitendeImStundenlohn?.bezahlteStunden?.max | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top border-bold-right">
            {{gesamtesUnternehmen?.mitarbeitendeImStundenlohn?.bezahlteStunden?.mittelwert | numberFormat: crtLocale }}
          </td>

          <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.mitarbeitendeImStundenlohn?.grundlohn?.min
            |
          numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.mitarbeitendeImStundenlohn?.grundlohn?.max
            |
          numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top border-bold-right">
          {{gesamtesUnternehmen?.mitarbeitendeImStundenlohn?.grundlohn?.mittelwert | numberFormat: crtLocale }}</td>

          <td class="text-align-right border-bold-top">
          {{gesamtesUnternehmen?.mitarbeitendeImStundenlohn?.gesamtverdienst?.min | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top">
          {{gesamtesUnternehmen?.mitarbeitendeImStundenlohn?.gesamtverdienst?.max | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top border-bold-right">
            {{gesamtesUnternehmen?.mitarbeitendeImStundenlohn?.gesamtverdienst?.mittelwert | numberFormat: crtLocale }}
          </td>

          @if (!isForM2) {
            <td class="text-align-right border-bold-top">
              {{gesamtesUnternehmen?.abweichungGeschlechtsneutralenGesamtverdienst?.maenner}}
            </td>
            <td class="text-align-right border-bold-top">
              {{gesamtesUnternehmen?.abweichungGeschlechtsneutralenGesamtverdienst?.frauen}}
            </td>
            <td class="text-align-right border-bold-top border-bold-right">
              {{gesamtesUnternehmen?.abweichungGeschlechtsneutralenGesamtverdienst?.gesamt}}
            </td>
          }
        </tr>
        <tr>
          @if (!isForM2) {
            <td colspan="32" class="hint pt-1" translate>
              m1.sprint10.cockpit.card.weitereFunktionenstatistiken.footer-hint
            </td>
          }
          @if (isForM2) {
            <td colspan="30" class="hint pt-1" translate>
              m2.sprint9.cockpit.card.weitereFunktionenstatistiken.footer-hint
            </td>
          }
        </tr>
        <tfoot>
        </table>
      </div>

      <div class="pdb-50"></div>

      @if (!isForM2) {
        <div>
          <app-chart-download-button (buttonClick)="exportTable2()">
            <h2 class="title" translate>m1.sprint9.cockpit.card.funktionenstatistiken.bst-anf.subtitle</h2>
          </app-chart-download-button>
          <div  class="table-wrapper">
            <table id="wfunkstat.bst-anf" class="striped">
              <thead>
                <tr>
                  <th rowspan="2" scope="col" class="header bold centered border-bold-left border-bold-right" translate>
                  m1.sprint10.cockpit.card.weitereFunktionenstatistiken.bst</th>
                  <th rowspan="2" scope="col" class="header bold centered border-bold-right" translate>
                  m1.sprint10.cockpit.card.weitereFunktionenstatistiken.bkn</th>
                  <th rowspan="2" colspan="8" scope="colgroup" class="header bold centered border-bold-right" translate>
                  m2.sprint9.cockpit.card.weitereFunktionenstatistiken.ausbildung</th>
                  <th rowspan="1" colspan="9" scope="colgroup" class="header bold centered border-bold-right" translate>
                  m2.sprint9.cockpit.card.weitereFunktionenstatistiken.imMonatslohnArbeitspensumLohn</th>
                  <th rowspan="1" colspan="9" scope="colgroup" class="header bold centered border-bold-right" translate>
                  m2.sprint9.cockpit.card.weitereFunktionenstatistiken.imStundenlohnArbeitspensumLohn</th>
                  @if (!isForM2) {
                    <th rowspan="1" colspan="3" scope="colgroup" class="header bold centered border-bold-right"
                    translate>m1.sprint10.cockpit.card.weitere-funktionenstatistiken.abweichung-gesamtverdienst</th>
                  }
                </tr>
                <tr>
                  <th scope="colgroup" colspan="3" class="header centered border-bold-right" translate>
                  m2.sprint9.cockpit.card.weitereFunktionenstatistiken.beschäftigungsgrad</th>
                  <th scope="colgroup" colspan="3" class="header centered border-bold-right" translate>
                  m2.sprint9.cockpit.card.weitereFunktionenstatistiken.grundlohnUnstandardisiert13</th>
                  <th scope="colgroup" colspan="3" class="header centered border-bold-right" translate>
                  m2.sprint9.cockpit.card.weitereFunktionenstatistiken.gesamtverdienstStandardisiert</th>
                  <th scope="colgroup" colspan="3" class="header centered border-bold-right" translate>
                  m2.sprint9.cockpit.card.weitereFunktionenstatistiken.bezahlteStunden</th>
                  <th scope="colgroup" colspan="3" class="header centered border-bold-right" translate>
                  m2.sprint9.cockpit.card.weitereFunktionenstatistiken.grundlohnUnstandardisiert13</th>
                  <th scope="colgroup" colspan="3" class="header centered border-bold-right" translate>
                  m2.sprint9.cockpit.card.weitereFunktionenstatistiken.gesamtverdienstStandardisiert</th>
                  @if (!isForM2) {
                    <th scope="colgroup" colspan="3" class="header centered border-bold-right" translate>
                    m1.sprint10.cockpit.card.weitere-funktionenstatistiken.diff-mittelwert</th>
                  }
                </tr>
                <tr>
                  <td class="centered border-bold-left border-bold-right"></td>
                  <td class="centered border-bold-right"></td>
                  @for (i of [].constructor(8); track i; let idx = $index; let isLast = $last) {
                    <td class="centered" [ngClass]="{'border-bold-right': isLast}">{{idx+1}}</td>
                  }
                  @for (i of [].constructor(6); track i; let idx = $index; let isLast = $last) {
                    <td class="centered" translate>i18n.common.min</td>
                    <td class="centered" translate>i18n.common.max</td>
                    <td class="centered border-bold-right" translate>
                    m2.sprint9.cockpit.card.weitereFunktionenstatistiken.mittelwert</td>
                  }
                  <td class="centered" translate>i18n.common.maenner</td>
                  <td class="centered" translate>i18n.common.frauen</td>
                  <td class="centered border-bold-right" translate>i18n.common.gesamt</td>
                </tr>
              </thead>
              <tbody>
                @for (item of nachCodierung; track item) {
                  <tr class="content">
                    <td class="text-align-right border-bold-left border-bold-right">{{item.BST}}</td>
                    <td class="text-align-right border-bold-right">{{item.BKN}}</td>
                    @for (i of [].constructor(8); track i; let isLast = $last; let idx = $index) {
                      <td class="text-align-right" [ngClass]="{'border-bold-right': isLast}">{{item?.ausbildung[idx+1] |
                      numberFormat: crtLocale }}</td>
                    }
                    <td class="text-align-right">{{item?.mitarbeitendeImMonatslohn?.beschaeftigungsgrad?.min | numberFormat:
                    crtLocale }}</td>
                    <td class="text-align-right">{{item?.mitarbeitendeImMonatslohn?.beschaeftigungsgrad?.max | numberFormat:
                    crtLocale }}</td>
                    <td class="text-align-right border-bold-right">
                    {{item?.mitarbeitendeImMonatslohn?.beschaeftigungsgrad?.mittelwert | numberFormat: crtLocale }}</td>
                    <td class="text-align-right">{{item?.mitarbeitendeImMonatslohn?.grundlohn?.min | numberFormat: crtLocale }}
                    </td>
                    <td class="text-align-right">{{item?.mitarbeitendeImMonatslohn?.grundlohn?.max | numberFormat: crtLocale }}
                    </td>
                    <td class="text-align-right border-bold-right">{{item?.mitarbeitendeImMonatslohn?.grundlohn?.mittelwert |
                    numberFormat: crtLocale }}</td>
                    <td class="text-align-right">{{item?.mitarbeitendeImMonatslohn?.gesamtverdienst?.min | numberFormat: crtLocale
                    }}</td>
                    <td class="text-align-right">{{item?.mitarbeitendeImMonatslohn?.gesamtverdienst?.max | numberFormat: crtLocale
                    }}</td>
                    <td class="text-align-right border-bold-right">{{item?.mitarbeitendeImMonatslohn?.gesamtverdienst?.mittelwert
                      |
                    numberFormat: crtLocale }}</td>
                    <td class="text-align-right">{{item?.mitarbeitendeImStundenlohn?.bezahlteStunden?.min | numberFormat:
                      crtLocale
                    }}</td>
                    <td class="text-align-right">{{item?.mitarbeitendeImStundenlohn?.bezahlteStunden?.max | numberFormat:
                      crtLocale
                    }}</td>
                    <td class="text-align-right border-bold-right">
                      {{item?.mitarbeitendeImStundenlohn?.bezahlteStunden?.mittelwert|
                    numberFormat: crtLocale }}</td>
                    <td class="text-align-right">{{item?.mitarbeitendeImStundenlohn?.grundlohn?.min | numberFormat: crtLocale }}
                    </td>
                    <td class="text-align-right">{{item?.mitarbeitendeImStundenlohn?.grundlohn?.max | numberFormat: crtLocale }}
                    </td>
                    <td class="text-align-right border-bold-right">{{item?.mitarbeitendeImStundenlohn?.grundlohn?.mittelwert |
                    numberFormat: crtLocale }}</td>
                    <td class="text-align-right">{{item?.mitarbeitendeImStundenlohn?.gesamtverdienst?.min | numberFormat:
                      crtLocale
                    }}</td>
                    <td class="text-align-right">{{item?.mitarbeitendeImStundenlohn?.gesamtverdienst?.max | numberFormat:
                      crtLocale
                    }}</td>
                    <td class="text-align-right border-bold-right">{{item?.mitarbeitendeImStundenlohn?.gesamtverdienst?.mittelwert
                      |
                    numberFormat: crtLocale }}</td>
                    <td class="text-align-right">
                      {{item.abweichungGeschlechtsneutralenGesamtverdienst?.maenner}}
                    </td>
                    <td class="text-align-right">
                      {{item.abweichungGeschlechtsneutralenGesamtverdienst?.frauen}}
                    </td>
                    <td class="text-align-right border-bold-right">
                      {{item.abweichungGeschlechtsneutralenGesamtverdienst?.gesamt}}
                    </td>
                  </tr>
                }
              </tbody>
              <tfoot>
                <!-- total row -->
                <tr class="content">
                  <th scope="col" colspan="1" class="border-bold-left border-bold-right border-bold-top" translate>
                  i18n.common.total</th>
                  <td class="text-align-right border-bold-right border-bold-top"></td>
                  @for (i of [].constructor(8); track i; let isLast = $last; let idx = $index) {
                    <td class="text-align-right border-bold-top" [ngClass]="{'border-bold-right': isLast}">
                    {{gesamtesUnternehmen?.ausbildung[idx+1] | numberFormat: crtLocale }}</td>
                  }
                  <td class="text-align-right border-bold-top">
                  {{gesamtesUnternehmen?.mitarbeitendeImMonatslohn?.beschaeftigungsgrad?.min | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">
                  {{gesamtesUnternehmen?.mitarbeitendeImMonatslohn?.beschaeftigungsgrad.max | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top border-bold-right">
                    {{gesamtesUnternehmen?.mitarbeitendeImMonatslohn?.beschaeftigungsgrad?.mittelwert | numberFormat: crtLocale
                    }}
                  </td>
                  <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.mitarbeitendeImMonatslohn?.grundlohn?.min
                    |
                  numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.mitarbeitendeImMonatslohn?.grundlohn?.max
                    |
                  numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top border-bold-right">
                  {{gesamtesUnternehmen?.mitarbeitendeImMonatslohn?.grundlohn?.mittelwert | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">
                  {{gesamtesUnternehmen?.mitarbeitendeImMonatslohn?.gesamtverdienst?.min | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">
                  {{gesamtesUnternehmen?.mitarbeitendeImMonatslohn?.gesamtverdienst?.max | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top border-bold-right">
                    {{gesamtesUnternehmen?.mitarbeitendeImMonatslohn?.gesamtverdienst?.mittelwert | numberFormat: crtLocale }}
                  </td>
                  <td class="text-align-right border-bold-top">
                  {{gesamtesUnternehmen?.mitarbeitendeImStundenlohn?.bezahlteStunden?.min | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">
                  {{gesamtesUnternehmen?.mitarbeitendeImStundenlohn?.bezahlteStunden?.max | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top border-bold-right">
                    {{gesamtesUnternehmen?.mitarbeitendeImStundenlohn?.bezahlteStunden?.mittelwert | numberFormat: crtLocale }}
                  </td>
                  <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.mitarbeitendeImStundenlohn?.grundlohn?.min
                    |
                  numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.mitarbeitendeImStundenlohn?.grundlohn?.max
                    |
                  numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top border-bold-right">
                  {{gesamtesUnternehmen?.mitarbeitendeImStundenlohn?.grundlohn?.mittelwert | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">
                  {{gesamtesUnternehmen?.mitarbeitendeImStundenlohn?.gesamtverdienst?.min | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">
                  {{gesamtesUnternehmen?.mitarbeitendeImStundenlohn?.gesamtverdienst?.max | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top border-bold-right">
                    {{gesamtesUnternehmen?.mitarbeitendeImStundenlohn?.gesamtverdienst?.mittelwert | numberFormat: crtLocale }}
                  </td>
                  <td class="text-align-right border-bold-top">
                    {{gesamtesUnternehmen?.abweichungGeschlechtsneutralenGesamtverdienst?.maenner}}
                  </td>
                  <td class="text-align-right border-bold-top">
                    {{gesamtesUnternehmen?.abweichungGeschlechtsneutralenGesamtverdienst?.frauen}}
                  </td>
                  <td class="text-align-right border-bold-top border-bold-right">
                    {{gesamtesUnternehmen?.abweichungGeschlechtsneutralenGesamtverdienst?.gesamt}}
                  </td>
                </tr>
                <tr>
                  <td colspan="12" class="hint pt-1" translate>m1.sprint10.cockpit.card.weitereFunktionenstatistiken.footer-hint</td>
                </tr>
                <tfoot>
                </table>
              </div>
            </div>
          }
        </div>
